'use client';
import React, { useMemo } from 'react';
import { StyledIndustriesList } from '@/components/common/ygen/sections/industries-list/industries-list.style';
import { Col, Container, Row } from 'react-bootstrap';
import IndustrySingle from '@/components/common/ui/single-item/IndustrySingle';
import reactHtmlParser from 'react-html-parser';

const IndustriesList = ({ data, list }) => {
	// Memoize the list of industries to prevent unnecessary recalculations
	const industriesList = useMemo(() =>
			list?.child_pages?.list || [],
		[list?.child_pages?.list]
	);

	// Memoize the render function for each industry item
	const renderIndustryItem = useMemo(() =>
			industriesList.map((e, index) => {
				const imagePath = e?.images?.list?.[0]?.full_path;
				const title = reactHtmlParser(e?.page_data?.title);
				const slug = e?.page_data?.slug;

				return (
					<Col md={3} key={index} className={'fade-up'}>
						<IndustrySingle
							link={`/industries/${slug}`}
							img={imagePath}
							title={title}
							count={index + 1}
						/>
					</Col>
				);
			}),
		[industriesList]
	);

	return (
		<StyledIndustriesList className="JobList" data-scroll-section>
			<Container>
				<Row className="masonary-row">
					{industriesList.length > 0 && renderIndustryItem}
				</Row>
			</Container>
		</StyledIndustriesList>
	);
};


export default React.memo(IndustriesList);
